export const CATEGORIES = [
  { slug: "ia", label: "Intelligence artificielle, automatisation et outils numériques", short: "IA & outils numériques" },
  { slug: "reglementations", label: "Réglementations, données et facturation électronique", short: "Réglementations & données" },
  { slug: "cybersecurite", label: "Cybersécurité et nouvelles menaces", short: "Cybersécurité" },
  { slug: "organisation", label: "Organisation, compétences, données et pilotage", short: "Organisation & pilotage" },
];

export const IMPORTANCE = [
  { slug: "a-connaitre", label: "À connaître" },
  { slug: "a-preparer", label: "À préparer" },
  { slug: "a-surveiller", label: "À surveiller" },
];

export const STATUSES = [
  { slug: "brouillon", label: "Brouillon" },
  { slug: "a-verifier", label: "À vérifier" },
  { slug: "valide", label: "Validé" },
  { slug: "publie", label: "Publié" },
  { slug: "archive", label: "Archivé" },
];

export const categoryLabel = (slug) => CATEGORIES.find((c) => c.slug === slug)?.label || slug;
export const categoryShort = (slug) => CATEGORIES.find((c) => c.slug === slug)?.short || slug;
export const importanceLabel = (slug) => IMPORTANCE.find((i) => i.slug === slug)?.label || slug;
export const statusLabel = (slug) => STATUSES.find((s) => s.slug === slug)?.label || slug;

export const importanceClass = (slug) => {
  switch (slug) {
    case "a-connaitre":
      return "border-bz-amber text-bz-amber";
    case "a-preparer":
      return "border-bz-petrol text-bz-petrol";
    case "a-surveiller":
      return "border-bz-slate text-bz-slate";
    default:
      return "border-bz-line text-bz-slate";
  }
};

export const statusClass = (slug) => {
  switch (slug) {
    case "publie":
      return "bg-bz-petrol text-white";
    case "brouillon":
      return "bg-bz-line text-bz-slate";
    case "a-verifier":
      return "bg-bz-amber/20 text-bz-amber";
    case "valide":
      return "bg-bz-navy/10 text-bz-navy";
    case "archive":
      return "bg-bz-slate/20 text-bz-slate";
    default:
      return "bg-bz-line text-bz-slate";
  }
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};
